module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/71e403944f2a2c2061e96000577f7b5b.png";